import { render, staticRenderFns } from "./ClientCashbackList.vue?vue&type=template&id=2e12b879&scoped=true"
import script from "./ClientCashbackList.vue?vue&type=script&lang=js"
export * from "./ClientCashbackList.vue?vue&type=script&lang=js"
import style0 from "./ClientCashbackList.vue?vue&type=style&index=0&id=2e12b879&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e12b879",
  null
  
)

export default component.exports